// extracted by mini-css-extract-plugin
module.exports = {"social":"social-module--social--1yRv9","item":"social-module--item--Dpvg2"};